import springApi from '../../services/springApi'

export const getClickLogs = params => (
	new Promise((resolve, reject) => {
		springApi()
			.get('/click_logs', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeClickLog = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/click_logs', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)